<template>
  <div id="dashboard-page" style="margin-bottom:55px;">
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/invoice">Invoice</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="3"></b-col>
        <b-col md="3">
          <div class="d-flex align-items-center float-right">
            <b-button
              variant="primary"
              v-if="model.status === 'CREATED'"
              class="btn-md mr-2 mt-3"
              @click="showModalInvoice()"
            >
              <font-awesome-icon icon="check-circle"></font-awesome-icon> Submit
            </b-button>
            <b-button
              variant="warning"
              v-if="model.status === 'CANCELED'"
              class="btn-md mr-2 mt-3"
              @click="showModalInvoiceCreate()"
            >
              <font-awesome-icon icon="check-circle"></font-awesome-icon> Re Create
            </b-button>
            <b-button
              v-b-tooltip.hover.top
              title="Download to PDF"
              @click="doPrint()"
              variant="info"
              class="btn-download mt-3 float-right"
              ><font-awesome-icon icon="download"
            /></b-button>
          </div>
        </b-col>
      </b-row>
      <div class="border-bottom"></div>
      <div v-if="isLoading" style="z-index: 1000;">
        <div class="text-center text-primary my-2 h-100">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
        </div>
      </div>
      <div v-else>
        <b-form class="mt-4 mx-2">
          <b-row>
            <b-col md="6">
              <!-- <b-row>
              <b-col md="4"><label class="labels">Product Type</label></b-col>
              <b-col md="8"
                ><p>{{ model.productType !== '' ? model.productType : '-' }}</p></b-col
              >
            </b-row> -->
              <b-row>
                <b-col md="4"><label class="labels">Invoice ID</label></b-col>
                <b-col md="8"
                  ><p class="font-weight-bold">
                    {{ model.invoiceId !== null ? model.invoiceId : '-' }}
                  </p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Invoice Date</label></b-col>
                <b-col md="8"
                  ><p>
                    {{
                      model.invoiceStartDate !== null ? getDateTime(model.invoiceStartDate) : '-'
                    }}
                  </p></b-col
                >
              </b-row>

              <b-row>
                <b-col md="4"><label class="labels">Customer</label></b-col>
                <b-col md="8"
                  ><p>{{ model.customer !== null ? model.customer.name : '-' }}</p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Bank Account</label></b-col>
                <b-col md="8" class="d-flex">
                  <div v-if="editBank" class="d-flex w-75">
                    <b-form style="width:300px;" class="d-flex" v-on:submit.prevent="doEditBankAccount()">
                     <b-form-select class="w-100" v-model="model.bankAccount.uuid" :options="bankAccountList"></b-form-select>
                      <p class="ml-2" v-if="loadingEdit">please wait...</p>
                      <b-button v-else type="submit" size="sm" class="ml-2" style="height: 30px;" variant="primary">Save</b-button>
                    </b-form>
                  </div>
                  <p v-else style="width:200px;">{{ model.bankAccount !== null ? model.bankAccount.bank : '-' }}</p> <b-link class="px-1" @click="editBankAccount"><font-awesome-icon v-if="!editBank" icon="edit" />{{ editBank === false ? 'Edit' : 'Cancel' }}</b-link></b-col
                >
              </b-row>
              <b-row class="mt-2">
                <b-col md="4"><label class="labels">PIC</label></b-col>
                <b-col md="8"
                  ><p>{{ model.invoicePic !== null ? model.invoicePic : '-' }}</p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Note</label></b-col>
                <b-col md="8"
                  >
                  <p style="white-space: pre-wrap; padding:6px; border: 1px solid #f3f3fd;">{{ model.note !==null ? model.note : '-'}}</p>
                  </b-col
                >
              </b-row>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col md="4"><label class="font-weight-bold text-primary">TOTAL</label></b-col>
                <b-col md="8"
                  ><p>
                    {{ dataAccount.account.currency }}
                    {{ model.invoiceTotal !== null ? formatPrice(model.invoiceTotal) : '-' }}
                  </p></b-col
                >
              </b-row>

              <b-row>
                <b-col md="4"
                  ><label class="font-weight-bold text-success">PAYMENT TOTAL</label></b-col
                >
                <b-col md="8"
                  ><p>
                    {{ dataAccount.account.currency }}
                    {{
                      model.invoicePaymentTotal !== null
                        ? formatPrice(model.invoicePaymentTotal)
                        : '-'
                    }}
                  </p></b-col
                >
              </b-row>

              <b-row>
                <b-col md="4"
                  ><label class="font-weight-bold text-danger">UNPAID BILL</label></b-col
                >
                <b-col md="8"
                  ><p>
                    {{ dataAccount.account.currency }}
                    {{
                      model.invoiceUnpaidBill !== null ? formatPrice(model.invoiceUnpaidBill) : '-'
                    }}
                  </p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Status</label></b-col>
                <b-col md="8"
                  ><h1>
                    <b-badge :variant="getStatusColor(model.status)">{{
                      getStatusName(model.status)
                    }}</b-badge>
                  </h1>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="mt-5 mb-3">
            <b-col md="12">
              <h4 class="text-uppercase">Invoice History Payment</h4>
              <b-row>
                <b-col md="12" class="mt-3">
                  <table class="table table-responsive table-striped">
                    <thead class="font-semibold">
                      <tr>
                        <th width="190px">Date</th>
                        <th width="190px">Payment Ref Number</th>
                        <th width="190px">Payment To</th>
                        <th width="190px">Ammount</th>
                        <th width="190px">Note</th>
                        <th width="190px">Change By</th>
                        <th width="100px">Photo</th>
                        <th width="60px"></th>
                      </tr>
                    </thead>
                    <tbody v-if="invoiceHistoryPayment.length > 0">
                      <tr v-for="history in invoiceHistoryPayment" :key="history.uuid">
                        <td>
                          <p v-text="getDateTime(history.paymentDate)"></p>
                        </td>
                        <td>
                          <p v-text="history.paymentRefNumber ? history.paymentRefNumber : '-'"></p>
                        </td>
                        <td>
                          <p v-text="history.paymentTo ? history.paymentTo.bank : '-'"></p>
                        </td>
                        <td>
                          <p>
                            {{ dataAccount.account.currency }}
                            {{
                              history.paymentAmmount !== null
                                ? formatPrice(history.paymentAmmount)
                                : '-'
                            }}
                          </p>
                        </td>
                        
                        <td>
                          <p v-text="history.paymentNote ? history.paymentNote : '-'"></p>
                        </td>
                        <td>
                          <p
                            v-text="history.changedBy.firstName + ' ' + history.changedBy.lastName"
                          ></p>
                        </td>
                        <td class="pointer">
                          <viewer>
                            <b-row>
                              <b-col md="3">
                                <p
                                  class="text-secondary text-center d-flex"
                                  v-if="history.paymentReceipt === null"
                                >
                                  <i>No Photo Submitted</i>
                                </p>
                                <b-img
                                  v-else
                                  :src="history.paymentReceipt"
                                  v-b-tooltip.focus
                                  class="img-responsive border-radius"
                                  style="margin-top: -18px;"
                                  width="30"
                                  height="30"
                                />
                              </b-col>
                            </b-row>
                          </viewer>
                        </td>
                        <td>
                          <b-button variant="white" title="Download Receipt" style="outline: none; border: none; margin-top: -18px;" @click="() => exportInvoiceReceipt(history)">
                            <b-icon icon="cloud-download" scale="1" class="text-success text-bold" aria-hidden="true"></b-icon>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <div class="text-center font-italic text-uppercase w-100">
                        no history payment
                      </div>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="mt-5 mb-3">
            <b-col md="12">
              <h4 class="text-uppercase">Invoice History Status</h4>
              <b-row>
                <b-col md="8" class="mt-3">
                  <table class="table table-responsive table-striped">
                    <thead>
                      <tr>
                        <th width="190px">Date</th>
                        <th width="190px">Status</th>
                        <th width="190px">Note</th>
                        <th width="190px">Changed BY</th>
                      </tr>
                    </thead>
                    <tbody v-if="invoiceHistoryStatus.length > 0">
                      <tr v-for="story in invoiceHistoryStatus" :key="story.uuid">
                        <td>
                          <p v-text="getDateTime(story.createdAt)"></p>
                        </td>
                        <td>
                          <p v-text="story.status ? story.status : '-'"></p>
                        </td>
                        <td>
                          <p v-text="story.note ? story.note : '-'"></p>
                        </td>
                        <td>
                          <p
                            v-text="story.changedBy.firstName + ' ' + story.changedBy.lastName"
                          ></p>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <div class="text-center font-italic text-uppercase w-100">
                        no history status
                      </div>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="mt-5 mb-2">
            <b-col md="12">
              <h4 class="text-uppercase">invoice Item</h4>
              <b-row>
                <b-col>
                  <table class="table table-responsive table-striped">
                    <thead>
                      <tr>
                        <th>TYPE</th>
                        <th width="120px">ITEM ID</th>
                        <th width="380px">NAME</th>
                        <th>QTY</th>
                        <th width="190px" v-if="salesType === 'Personal'">PRICE</th>
                        <th width="190px" v-else-if="salesType === 'Corporate'">PRICE</th>
                        <th width="190px" v-else>PRICE</th>
                        <th width="90px">Disc</th>
                        <th width="190px">Total</th>
                        <th width="190px">Total Discount</th>
                        <th width="190px">Subtotal</th>
                        <th width="190px">Tax</th>
                        <th width="190px">Grand Total</th>
                      </tr>
                    </thead>
                    <tbody v-if="invoiceItem.length > 0">
                      <tr v-for="invoice in invoiceItem" :key="invoice.uuid">
                        <td>
                          <p v-text="invoice.itemList.productType"></p>
                        </td>
                        <td>
                          <p v-text="invoice.itemList.itemId"></p>
                        </td>
                        <td>
                          <p style="white-space: pre-line" v-text="invoice.itemList.name"></p>
                        </td>
                        <td>
                          <p v-text="invoice.quantity"></p>
                        </td>
                        <td v-if="invoice.customPrice > 0">
                          <p>
                            {{ dataAccount.account.currency }}
                            {{
                              invoice.customPrice !== null ? formatPrice(invoice.customPrice) : '-'
                            }}
                          </p>
                        </td>

                        <td v-else-if="salesType === 'Personal'">
                          <p>
                            {{ dataAccount.account.currency }}
                            {{
                              invoice.itemList.normal_price !== null
                                ? formatPrice(invoice.itemList.normal_price)
                                : '-'
                            }}
                          </p>
                        </td>
                        <td v-else>
                          <p>
                            {{ dataAccount.account.currency }}
                            {{
                              invoice.itemList.corporate_price !== null
                                ? formatPrice(invoice.itemList.corporate_price)
                                : '-'
                            }}
                          </p>
                        </td>
                        

                        <td>
                          <p v-text="invoice.discount + ' %'"></p>
                        </td>
                        <td>
                          <p>
                            {{ dataAccount.account.currency }}
                            {{ invoice.subTotal !== null ? formatPrice(invoice.subTotal) : '-' }}
                          </p>
                        </td>
                        <td>
                          <p>
                            {{ dataAccount.account.currency }}
                            {{
                              invoice.totalDiscount !== null
                                ? formatPrice(invoice.totalDiscount)
                                : '-'
                            }}
                          </p>
                        </td>
                        <td>
                          <p>
                            {{ dataAccount.account.currency }}
                            {{
                              invoice.totalPriceAfterDiscount !== null
                                ? formatPrice(invoice.totalPriceAfterDiscount)
                                : '-'
                            }}
                          </p>
                        </td>
                        <td>
                          <p>
                            {{ taxes }}
                          </p>
                        </td>
                        <td>
                          <p>
                            {{ dataAccount.account.currency }}
                            {{
                              invoice.totalPriceAfterTax !== null
                                ? formatPrice(invoice.totalPriceAfterTax)
                                : '-'
                            }}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <div class="text-center font-italic text-uppercase">
                        no item
                      </div>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
              <b-card class="mt-5 mb-4 bordered-card" bg-variant="light">
                <b-row class="mt-5">
                  <b-col md="8">
                    <b-row>
                      <b-col md="2">
                        <label class="labels">Due Date</label>
                      </b-col>
                      <b-col md="3">
                        <p v-text="getDateTime(model.invoiceDueDate)"></p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2">
                        <label class="labels">Created By</label>
                      </b-col>
                      <b-col md="3">
                        <div class="font-weight-bold">
                          {{ $store.getters['account/accountData'].firstName }}
                          {{ $store.getters['account/accountData'].lastName }}
                        </div>
                      </b-col>
                    </b-row>
                    <div v-if="model.status === 'UNPAID'">
                      <b-row class="mt-5">
                        <b-col md="2">
                          <label class="labels">Submit Date</label>
                        </b-col>
                        <b-col md="3">
                          <p v-text="getDateTime(model.submittedDate)"></p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="2">
                          <label class="labels">Submit By</label>
                        </b-col>
                        <b-col md="3">
                          <p>
                            {{ $store.getters['account/accountData'].firstName }}
                            {{ $store.getters['account/accountData'].lastName }}
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <label class="labels">Signed By</label>
                    <p
                      class="mt-5"
                      v-text="
                        model.signedBy !== null
                          ? model.signedBy.firstName + ' ' + model.signedBy.lastName
                          : '-'
                      "
                    ></p>
                  </b-col>
                  <b-col md="4" class="mt-3"> </b-col>
                </b-row>
                <b-row>
                  <b-col md="5"> </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <b-button class="mt-3" @click="goBack()" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
      <b-button
        v-if="model.status === 'CREATED'"
        class="mt-3 float-right"
        :to="'/sales/invoice/' + $route.params.uuid + '/edit'"
        variant="warning"
        ><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button
      >
      <b-modal id="bv-modal-submit" hide-footer>
        <template v-slot:modal-title>
          <!-- <h5 class="text-transform">{{type}} Overtime</h5> -->
        </template>
        <form v-on:submit.prevent="doChangeStatus(type)">
          <div class="d-block"></div>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-submit')"
            ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
          >
          <b-button variant="primary" type="submit" class="mt-4 float-right"
            ><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon
            ><font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button
          >
        </form>
      </b-modal>
      <b-modal id="bv-modal-invoice" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Change Status</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatusInvoice()">
          <template>
            <div class="d-block">
              <!-- <label for="" class="labels">Status</label> -->
              <!-- <b-form-select rows="3" v-model="formData.status" :options="statusList" placeholder="Enter Note"></b-form-select> -->
              <label for="" class="labels">Note</label>
              <b-form-textarea
                rows="3"
                v-model="formData.note"
                placeholder="Enter Note"
              ></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-invoice')"
            ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
          >
          <b-button variant="primary" type="submit" class="mt-4 float-right"
            ><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon>
            <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button
          >
        </form>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
import wysiwyg from 'vue-wysiwyg';
Vue.use(wysiwyg, {
  hideModules: {
    headings: true,
    code: true,
    link: true,
    image: true,
    table: true,
    unorderedList: true,
    separator: true,
    maxHeight: '100px'
  },
}); // config is optional. more below
Vue.use(Viewer);
export default {
  name: 'items-details',
  data() {
    return {
      loaderDownload: false,
      editBank: false,
      isLoading: false,
      loadingEdit: false,
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        itemList: window.AppConfig.apiUrl + 'item-list',
        invoice: window.AppConfig.apiUrl + 'invoice',
        exportInvoiceDetail: window.AppConfig.apiUrl + 'export-invoice-detail',
        exportReceipt: window.AppConfig.apiUrl + 'export-invoice-payment-receipt'
      },
      formData: {
        status: null,
        note: null,
        changedBy: this.$store.getters['account/accountData'].uuid,
      },
      model: {
        uuid: '',
        isSigned: null,
        isStamp: null,
        customer: null,
        signedBy: null,
        invoiceId: '',
        submittedDate: '',
        subject: '',
        invoicePic: '',
        tax: '',
        bankAccount: '',
        taxValue: null,
        invoiceDueDate: '',
        invoiceStartDate: '',
        status: null,
        invoiceItem: [],
        invoiceHistoryPayment: [],
        invoiceHistoryStatus: [],
        note: '',
        invoice: '',
        normalPrice: '',
        corporatePrice: '',
        createdBy: this.$store.getters['account/accountData'].uuid,
      },
      currency: '',
      invoiceItem: [],
      invoiceHistoryPayment: [],
      bankAccountList: [],
      signedByName: [],
      salesType: '',
      taxes: '',
      totalTax: '',
      invoiceHistoryStatus: '',
      dataHistory: ""
    };
  },
  watch: {
    'this.history.uuid'(value){
      this.loadingEvent(value)
    }
  },
  
  mounted() {
    this.getDetail();
    this.getStatusColor();
    this.getStatusName();
  },
  methods: {
    // showModal() {
    //   // this.formData.note = null;
    //   // this.type = type;
    //   this.$bvModal.show('bv-modal-submit');
    // },
    showModalInvoiceCreate() {
      this.formData.status = 'CREATED';
      this.modelUuid = this.$route.params.uuid;
      this.$bvModal.show('bv-modal-invoice');
    },

     editBankAccount(){
      this.getBankAccountList();
      this.editBank = !this.editBank;
      this.model.invoice = this.model.uuid
    },

    doEditBankAccount(){
      this.loadingEdit = true;
      this.$http.post(window.AppConfig.apiUrl + "change-bank-invoice", {
        invoice: this.model.invoice,
        bankAccount: this.model.bankAccount
      }).then(()=>{
        setTimeout(()=>{
          this.$store.dispatch("notification/success", "Change Saved")
          this.loadingEdit = false
          this.editBankAccount()
          this.getDetail()
        }, 1500)
      }).catch(error=>{
        this.$store.dispatch("notification/error", error)
      })
    },

   

    showModalInvoice() {
      this.formData.status = 'UNPAID';
      this.modelUuid = this.$route.params.uuid;
      this.$bvModal.show('bv-modal-invoice');
    },
    doChangeStatusInvoice() {
      this.isLoading = true;
      this.$http
        .post(window.AppConfig.apiUrl + 'invoice-status', {
          invoice: this.modelUuid,
          status: this.formData.status,
          note: this.formData.note,
          changedBy: this.formData.changedBy,
        })
        .then(() => {
          this.isLoading = false;
          this.formData.note = null;
          this.formData.status = null;
          this.$bvModal.hide('bv-modal-invoice');
          this.$store.dispatch('notification/success', 'Invoice status has been changed');
          this.getDetail();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    doChangeStatus() {
      console.log('Status changed');
    },

    getBankAccountList(){
      this.$http.get(window.AppConfig.apiUrl + 'bank-account').then(resp=>{
        this.bankAccountList = []
        resp.data._embedded.bank_account.forEach(data=>{
          this.bankAccountList.push({
            value: data.uuid,
            text: data.bank
          })
        })
      })
    },

    getDetail() {
      this.isLoading = true;
      this.$http.get(this.apiUrl.invoice + '/' + this.$route.params.uuid).then((response) => {
        this.salesType = response.data.customer.salesType;
        console.log('sales', this.salesType);
        this.model.invoiceId =
          response.data.invoiceId !== null && response.data.invoiceId !== 'null'
            ? response.data.invoiceId
            : '-';
        this.model.subject =
          response.data.subject !== null && response.data.subject !== 'null'
            ? response.data.subject
            : '-';
        this.model.status =
          response.data.status !== null && response.data.status !== 'null'
            ? response.data.status
            : '-';
        this.model.isSigned =
          response.data.isSigned !== null && response.data.isSigned !== 'null'
            ? response.data.isSigned
            : '-';
        this.model.isStamp =
          response.data.isStamp !== null && response.data.isStamp !== 'null'
            ? response.data.isStamp
            : '-';

        this.model.uuid =
          response.data.uuid !== null && response.data.uuid !== 'null'
            ? response.data.uuid
            : '-';
        this.model.invoicePic =
          response.data.invoicePic !== null && response.data.invoicePic !== 'null'
            ? response.data.invoicePic
            : '-';
        this.model.invoiceTotal =
          response.data.invoiceTotal !== null && response.data.invoiceTotal !== 'null'
            ? response.data.invoiceTotal
            : '-';
        this.model.invoicePaymentTotal =
          response.data.invoicePaymentTotal !== null && response.data.invoicePaymentTotal !== 'null'
            ? response.data.invoicePaymentTotal
            : '-';
        this.model.invoiceUnpaidBill =
          response.data.invoiceUnpaidBill !== null ? response.data.invoiceUnpaidBill : '-';
        this.model.customer = response.data.customer !== null ? response.data.customer : '-';
        this.model.bankAccount = response.data.bankAccount !== null ? response.data.bankAccount : '-';
        this.model.signedBy = response.data.signedBy !== null ? response.data.signedBy : '-';
        this.model.note = response.data.note !== '' ? response.data.note : '-';
        this.model.invoiceStartDate =
          response.data.invoiceStartDate !== null ? response.data.invoiceStartDate : '-';
        this.model.invoiceDueDate =
          response.data.invoiceDueDate !== null ? response.data.invoiceDueDate : '-';
        this.model.submittedDate =
          response.data.submittedDate !== null ? response.data.submittedDate : '-';
        this.model.createdAt = response.data.createdAt !== null ? response.data.createdAt : '-';
        this.model.updatedAt = response.data.updatedAt !== null ? response.data.updatedAt : '-';
        this.currency = response.data.account.currency;
        if (response.data.taxValue !== null) {
          this.taxes = response.data.taxValue.name;
          console.log('tax', this.taxes);
        }

        this.invoiceItem = [];
        if (response.data.invoiceItem !== null) {
          response.data.invoiceItem.forEach((data) => {
            this.invoiceItem.push(data);
          });
        }
        this.invoiceHistoryPayment = [];
        if (response.data.invoiceHistoryPayment !== null) {
          response.data.invoiceHistoryPayment.forEach((data) => {
            this.invoiceHistoryPayment.push(data);
          });
        }
        this.invoiceHistoryStatus = [];
        if (response.data.invoiceHistoryStatus !== null) {
          response.data.invoiceHistoryStatus.forEach((data) => {
            this.invoiceHistoryStatus.push(data);
          });
        }
        this.isLoading = false;
        // this.totalTax = response.data.taxValue.value
        this.totalTax = response.data.invoiceItem.totalPriceAfterDiscount;

        console.log('total tax', this.totalTax);
      });
    },

    doPrint() {
      let url = this.apiUrl.exportInvoiceDetail + '?token=' + this.$store.getters['account/tokens'].access_token + '&invoice_uuid=' + this.$route.params.uuid;
      window.open(url);
      this.isLoading = false;
    },

    exportInvoiceReceipt(history){
      let url = this.apiUrl.exportReceipt + '?token=' + this.$store.getters['account/tokens'].access_token + '&invoice_payment_uuid=' + history.uuid
        if(history.uuid !== undefined){
           window.open(url);
            this.$store.dispatch("notification/success", "Download Successfuly");
          }
    },

    //format mata uang
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    //format waktu cth 2021-10-07
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD');
      } else {
        return '-';
      }
    },

    // kembali ke halaman sebelumnya
    goBack() {
      window.goBack(this);
    },

    //format jika mendapat status bernama (cth nama status) ubah menjadi .
    // getStatusColor(val) {
    //   if (val) {
    //     return 'success';
    //   } else {
    //     return 'secondary';
    //   }
    // },
    // getStatusName(val) {
    //   if (val) {
    //     return 'Headquarters';
    //   } else {
    //     return 'Branch';
    //   }
    // },

    //format untuk mengubah teks status
    getStatusName(val) {
      switch (val) {
        case 'CREATED':
          return 'CREATED';
        case 'UNPAID':
          return 'UNPAID';
        case 'PAID':
          return 'PAID';
        case 'CANCELED':
          return 'CANCELED';
      }
    },

    //format untuk warna badge pada status
    getStatusColor(value) {
      switch (value) {
        case 'UNPAID':
          return 'danger';
        case 'PAID':
          return 'primary';
        case 'CANCELED':
          return 'secondary';
        case 'CREATED':
          return 'warning';
        case 'Done':
          return 'primary'
        case 'DONE':
          return 'primary'
      }
    },
  },
};
</script>

<style scoped>
p {
  font-weight: 400;
}
</style>
